import Slider from 'react-slick';
import * as styles from './styles.css';
import { clsx } from 'clsx';
import { SliderStep } from '../SliderStep';
import { STEPS } from './constants';
import { useDeviceType } from '@cian/ui-kit';

type TArrowProps = { onClick?: VoidFunction };

export const CustomSlider: React.FC = () => {
  const device = useDeviceType();

  const isPhone = device === 'phone';

  const customPaging = (index: number) => {
    return (
      <div>
        {index + 1}
        {device === 'desktop' && ' шаг'}
      </div>
    );
  };

  const PrevArrow = ({ onClick }: TArrowProps) => {
    if (isPhone) {
      return null;
    }

    return <div onClick={onClick} className={clsx(styles['arrow'], styles['prev-arrow'])} />;
  };

  const NextArrow = ({ onClick }: TArrowProps) => {
    if (isPhone) {
      return null;
    }

    return <div onClick={onClick} className={clsx(styles['arrow'], styles['next-arrow'])} />;
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dotsClass: styles['dots'],
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    customPaging,
  };

  return (
    <div className={clsx(styles['slider'], styles[device])}>
      <Slider {...settings}>
        {STEPS.map(item => (
          <SliderStep key={item.id} {...item} />
        ))}
      </Slider>
    </div>
  );
};
